const mode = process.env.REACT_APP_ENV;
const API_URL =
  mode === "development"
    ? process.env.REACT_APP_LOCAL_API_URL
    : process.env.REACT_APP_LIVE_API_URL;


export const env = Object.freeze({
  API_URL,
});
